export default __webpack_public_path__ + "static/media/homedashboard.c41245b7.svg";